module.exports = __webpack_public_path__ + "static/media/trumpet.09493911.wav";